document.addEventListener('DOMContentLoaded', function() {
    const videos = document.querySelectorAll('video');
    const MAX_RETRY = 3; // 최대 재시도 횟수 설정

    // Observer 옵션: 30% 이상 보일 때 재생, 이하면 정지.
    const observerOptions = {
        threshold: 0.3
    };

    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
            // 재시도 카운터 초기화 (없으면 0으로)
            if (typeof video.retryCount === 'undefined') {
                video.retryCount = 0;
            }
            
            if (video.paused) {
                // 재시도 횟수가 MAX_RETRY 미만일 때만 재생 시도
                if (video.retryCount < MAX_RETRY) {
                    video.play().then(() => {
                        // 재생 성공 시 재시도 카운터 초기화
                        video.retryCount = 0;
                    }).catch(error => {
                        video.retryCount++;
                        console.error('비디오 재생 오류:', error, '재시도 횟수:', video.retryCount);
                        // 필요 시, 일정 시간 지연 후 재시도 로직을 추가할 수 있음
                        // 또는 재시도 횟수가 MAX_RETRY 이상이면 fallback 동작 구현 가능
                    });
                } else {
                    console.warn('최대 재시도 횟수 도달: 더 이상 재생 시도하지 않습니다.');
                }
            }
        } else {
            video.pause();
        }
      });
    }, observerOptions);

    videos.forEach(video => {
        // preload 옵션을 'metadata' 또는 'none'으로 설정하여 불필요한 로드를 방지
        video.setAttribute('preload', 'metadata');
        videoObserver.observe(video);
    });
});